import React from 'react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  quote: 'Pegué la tabla de materiales en la pared del garaje y armé toda la lista de compras en 5 minutos. Fui al corralón con la hoja en la mano. El vendedor me quería vender el doble. Le mostré mi cálculo y me fui con lo que necesitaba.',
  name: 'Diego F.',
  desc: '📍 Rosario | Sistema Maestro completo'
}, {
  quote: 'El Módulo 3 me salvó la obra. Tenía la membrana del techo completamente rota y lo descubrí con la Prueba de Agua. Si hubiera inyectado los cimientos primero, la filtración del techo hubiera arruinado todo.',
  name: 'Roberto K.',
  desc: '📍 San Isidro | Sistema + Pasaporte'
}, {
  quote: 'Le mostré el Expediente Técnico al comprador de mi casa. Me preguntó si era arquitecto. Me ahorré $800.000 ARS de descuento por riesgo de humedad.',
  name: 'Sebastián V.',
  desc: '📍 Buenos Aires | Sistema + Pasaporte'
}];
export function TestimonialsSection() {
  return <section className="py-8 md:py-10 px-4 bg-slate-900 border-y border-slate-800/50" data-id="element-273">
      <div className="max-w-4xl mx-auto" data-id="element-274">
        <FadeIn data-id="element-275">
          <h2 className="text-orange-500 font-black tracking-widest uppercase text-sm mb-6 text-center" data-id="element-276">
            ❤️ MÁS PROPIETARIOS QUE YA LO RESOLVIERON
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-277">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-278">
              <div className="bg-slate-950 border border-slate-800 rounded-2xl p-5 md:p-6 relative" data-id="element-279">
                <div className="absolute top-4 right-6 text-6xl text-slate-800 font-serif leading-none opacity-50" data-id="element-280">
                  "
                </div>
                <div className="flex gap-1 mb-3 relative z-10" data-id="element-281">
                  {[...Array(5)].map((_, i) => <span key={i} className="text-orange-500 text-base" data-id="element-282">
                      ⭐
                    </span>)}
                </div>
                <p className="text-slate-300 italic mb-4 relative z-10 text-base md:text-lg" data-id="element-283">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 relative z-10" data-id="element-284">
                  <div data-id="element-285">
                    <p className="text-white font-bold text-sm" data-id="element-286">{t.name}</p>
                    <p className="text-slate-500 text-xs" data-id="element-287">{t.desc}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}